import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { CHAIN_NAMESPACES } from '@web3auth/base';

const PLUGIN_NAMESPACES = _objectSpread(_objectSpread({}, CHAIN_NAMESPACES), {}, {
  MULTICHAIN: "multichain"
});

export { PLUGIN_NAMESPACES };
//# sourceMappingURL=basePlugin.esm.js.map
